module.exports = "<select class=\"form-control\"\n        ng-if=\"$ctrl.mode === 'edit'\"\n    ng-attr-data-testid=\"{{$ctrl.testId}}\"\n        ng-model=\"$ctrl.ngModelId\"\n        ng-disabled=\"$ctrl.ngDisabled\"\n        ng-change=\"$ctrl._ngChange()\"\n        ng-options=\"item.id as item.name for item in $ctrl.list\">\n    <option ng-if=\"$ctrl.allowEmpty\" value=\"\">Select Company</option>\n</select>\n<span ng-if=\"$ctrl.mode === 'view'\" class=\"label label-default\" ng-bind=\"$ctrl.ngModel.name\" ng-style=\"$ctrl.colorStyle\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/company.picker.html
// module id = 584
// module chunks = 0